import {useMemo} from 'react';
import {useSelector} from 'react-redux';

import {isJourneyActionCompleted} from '@/services/loyalty/loyaltyUtils';
import {selectNotCompletedActions} from '@/state/selectors/consumerLoyalty';

export const useFirstNotCompletedAction = (journey?: any) => {
    const notCompletedAction = useSelector(selectNotCompletedActions)[0];

    return useMemo(() => {
        if (!journey) {
            return notCompletedAction;
        }

        for (const level of journey?.journeyLevels || []) {
            const action = level.memberJourneyActions?.find((o: any) => !isJourneyActionCompleted(o));

            if (action) {
                return {
                    ...action,
                    memberJourneyBadge: level.memberJourneyBadge,
                    levelActions: level.memberJourneyActions,
                };
            }
        }

        return undefined;
    }, [journey, notCompletedAction]);
};
